// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Qizmf","right":"styles_right__1H_1y"};